import { useCheckoutStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreCheckoutComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Page, type PageComponentProps } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CheckoutPage.module.scss";

export interface CheckoutPageComponentProps
  extends PlatformComponentProps,
    PageComponentProps {
  bottomSection?: JSX.Element;
  onContinue?: () => void;
  continueButtonDisabled?: boolean;
}
export const CheckoutPage = ({
  children,
  className,
  bottomSection,
  onContinue,
  continueButtonDisabled,
  ...restProps
}: CheckoutPageComponentProps) => {
  const COMPONENT_KEY = CoreCheckoutComponent.CheckoutPage;
  const styles = useCheckoutStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  return (
    <Page className={clsx(block, className)} {...restProps} footer={<></>}>
      {children}
      <div className={cn("bottom-floating-section")}>
        {bottomSection ? (
          bottomSection
        ) : (
          <button
            className={cn("continue_button")}
            onClick={() => onContinue?.()}
            disabled={continueButtonDisabled}
          >
            {t("continue")}
          </button>
        )}
      </div>
    </Page>
  );
};
